import { useTheme } from 'next-themes';
import classNames from 'classnames';
import Image from 'next/image';

import SectionTitle from '../SectionTitle/SectionTitle';
import CircleIcon from '../CircleIcon/CircleIcon';
import TextBlock from '../TextBlock/TextBlock';

import styles from './CardBlock.module.scss';

const Card = ({ data, point, icon, linkClassName }) => {
  const theme = useTheme();

  const renderIconOrText = (() => {
    switch (true) {
      case !!data?.icon:
        return (
          <CircleIcon
            path={
              theme.theme === 'dark' && data?.dark_mode_icon
                ? data.dark_mode_icon
                : data.icon
            }
            alt={data?.icon}
            className={
              data?.icon_background
                ? styles.gray_icon_wrapper
                : styles.icons_wrapper
            }
          />
        );
      case !!data?.image:
        return (
          <Image
            src={data?.image}
            className={styles.custom_icon}
            alt='icon'
            title='icon'
            loading='lazy'
            width={24}
            height={24}
          />
        );
      default:
        return (
          <CircleIcon className={styles.gray_icon_wrapper}>{point}</CircleIcon>
        );
    }
  })();

  const renderContent = (item, index) => {
    return (
      <a
        key={index}
        href={item?.url}
        target='_blank'
        rel='noreferrer'
        className={classNames([
          styles.card_external_link,
          { [styles.linkClassName]: linkClassName === true },
        ])}
      >
        {item?.text}
      </a>
    );
  };

  return (
    <article
      className={styles['card-item']}
      itemScope
      itemType='https://schema.org/Article'
    >
      <div className={styles['card-item__icon-wrapper']}>
        {icon ? (
          <Image
            src={icon}
            className={styles.custom_icon}
            alt='icon'
            title='icon'
            loading='lazy'
            width={24}
            height={24}
          />
        ) : (
          renderIconOrText
        )}
      </div>
      <div className={styles['card-item__content']}>
        {data?.title && (
          <SectionTitle titleModify={styles['card-item__title']}>
            {data.title}
          </SectionTitle>
        )}
        <div>
          {data?.content && Array.isArray(data.content)
            ? data?.content?.map(renderContent)
            : data?.content && (
                <TextBlock
                  titleModify={classNames([styles['card-item__desc']])}
                  isHtml
                >
                  {data.content}
                </TextBlock>
              )}
          {data?.description && (
            <TextBlock
              titleModify={classNames([styles['card-item__desc']])}
              isHtml
            >
              {data.description}
            </TextBlock>
          )}
        </div>
      </div>
    </article>
  );
};

export default Card;
